import axios from 'axios';

// Keep auth calls isolated from other service modules to avoid cross-coupling
// interceptor behavior with public, non-authenticated endpoints.
const api = axios.create({
    baseURL: process.env.VUE_APP_BACKEND_API_URL || 'http://localhost:3000/api',
    headers: {
        'X-API-KEY': process.env.VUE_APP_API_KEY,
    }
});

export const login = async (username, password) => { // use `username` instead of `email`
    try {
        const response = await api.post('/login', { username, password });
        return response.data;
    } catch (error) {
        // Re-throw backend-provided message so UI can show actionable login feedback.
        if (error.response && error.response.data) {
            throw new Error(error.response.data.error);
        } else {
            throw new Error('An error occurred during login');
        }
    }
};
